import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Invoice } from "@common/types/invoice";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Amount } from "@design-system/Amount/Amount";

export const AmountCell = memo(
    ({ row }: CellContext<ViewTableFeatures, Invoice, number>) => {
        const invoice = row.original;

        return (
            <ViewTableCell>
                <Amount amount={invoice.total} />
            </ViewTableCell>
        );
    },
);
